import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
  SimpleChanges} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
declare var $: any; 
import { PickerComponent } from '@ctrl/ngx-emoji-mart';
import { ChatService } from "src/app/chat.service";
import { ChatbotFunService } from "src/app/services/chatbot-fun.service";

@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class FooterComponent implements OnInit {
  @Input() inputValue: string;
  @Output() sendMsgEv = new EventEmitter();
  @ViewChild("inputRef", { static: true }) inputRef: ElementRef;
  @ViewChild('emojiPicker', { static: false }) emojiPicker!: ElementRef;
  @ViewChild('emojiButton', { static: false }) emojiButton!: ElementRef;  @Output() inputValueChange = new EventEmitter();
  @Output() fileUploadEv = new EventEmitter();
  showEmoj = true;
  lang='';
 canSendMessage = true;
 @Input() chatbot_lang;
 @Input() registrationForm: boolean;

  constructor(private route: ActivatedRoute, public chatbotFunService: ChatbotFunService, private chat: ChatService,) {}

  ngOnInit() {
    console.log('registrationForm ---> ', this.registrationForm);

    this.route.queryParams.subscribe((params) => {
      if (params['lang']) {
        this.chatbot_lang = params['lang'];
      }else{
        this.chatbot_lang='ar';
      }
    });
 

  }

  ngOnChanges(): void {
    this.registrationFormInput();
  }
  
  change(newValue) {
    this.inputValue = newValue;
    this.inputValueChange.emit(newValue);
  }

  async sendMessage() {
    this.canSendMessage = false;

    // Introduce a delay using a Promise
    await new Promise(resolve => setTimeout(resolve, 1000));
  
    this.canSendMessage = true;
    this.sendMsgEv.emit(true);
    this.inputRef.nativeElement.value = null;
  }
  
  importFile(files: File[]) {
    this.fileUploadEv.emit(files);
}
  addEmoji(event) {

    if (!this.inputValue) {
      this.inputValue = "";
    }

    this.inputValue = this.inputValue + event.emoji.native;
    $("#text").val($("#text").val() + event.emoji.native);
    this.inputValueChange.emit(this.inputValue);
    this.showEmoj = !this.showEmoj;

    console.log(event)
    console.log(this.inputValue)

  }

  switchEmoj() {
    this.showEmoj = !this.showEmoj;
    console.log('enter');
    if (this.showEmoj == true) {
      $(".float-icon").css("z-index", "99");
    } else {
      console.log("open it ");
      $(".float-icon").css("z-index", "0");
    }
  }

  showEmojiPicker = false;

  toggleEmojiPicker(event: Event) {
    event.stopPropagation(); // Prevents closing when clicking the button
    this.showEmojiPicker = !this.showEmojiPicker;

    // Delay the document click listener to avoid immediate closure
    setTimeout(() => {
      document.addEventListener('click', this.handleOutsideClick);
    });
  }
  handleOutsideClick = (event: Event) => {
    if (
      this.emojiPicker &&
      this.emojiPicker.nativeElement &&
      !this.emojiPicker.nativeElement.contains(event.target) &&
      this.emojiButton &&
      this.emojiButton.nativeElement &&
      !this.emojiButton.nativeElement.contains(event.target) // Ensure clicking the button doesn’t close it
    ) {
      this.showEmojiPicker = false;
      document.removeEventListener('click', this.handleOutsideClick);
    }
  };

  registrationFormInput(): void {
    let value = this.registrationForm;

    if (value) {
      this.registrationForm = true;
    }else{
      this.registrationForm = false;
    }
  }

  ngOnDestroy() {
    document.removeEventListener('click', this.handleOutsideClick);
  }
}
